export default "__VITE_ASSET__DWEpWwpV__"